import React, { FC } from 'react';
import { AssistantContainerResponse } from './AssistantContainerResponse';
import { IConversationRun } from '../model/ConversationRun';
import { useConversationRun } from './hooks/useConversationRun';

export const AssistantResponse: FC<{ run: IConversationRun; isLastRun: boolean }> = (props) => {
    const { run, isLastRun } = props;
    const { containers } = useConversationRun(run);

    return (
        <div data-testid="assistant-response">
            {containers.map((container) => {
                return (
                    <div data-testid={container.getId()} key={container.getId()}>
                        <AssistantContainerResponse container={container} run={run} isLastRun={isLastRun} />
                    </div>
                );
            })}
        </div>
    );
};
